import { Tool } from '@procureai/agents';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolErrorIndicator } from '../ChatMessage/indicators/ChatToolErrorIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import { I18nNamespace } from '~/common/types';

import { ToolResultComponent } from '.';

/** Simplified output model for runSourceSuppliers tool call */
type SourceSuppliersOutput =
  | {
      success: false;
      error: string;
    }
  | {
      success: 'partial';
      error: string;
      suppliers: Record<string, unknown>[];
    }
  | {
      success: true;
      suppliers: Record<string, unknown>[];
    };

export const RunSourceSuppliers: ToolResultComponent<Tool.runSourceSuppliers, unknown, SourceSuppliersOutput> = ({
  tool,
  toolName,
}) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${toolName}` });

  const errorComponent = <ChatToolErrorIndicator message={t(`error`)} />;

  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return <ChatLoadingIndicator message={t(`call`)} />;

    case 'output-available': {
      if (tool.output.success === true) {
        return <ChatToolResultIndicator message={t(`result`)} />;
      } else if (tool.output.success === 'partial') {
        return <ChatToolResultIndicator message={t(`partial`)} />;
      }
      return errorComponent;
    }
    case 'output-error':
      return errorComponent;
  }
};
